import React from 'react';
import SearchAndBook from '../components/SearchAndBook';

const EventCreation = () => {
  return <SearchAndBook />;
};

export default EventCreation;